import { useQuery } from "@tanstack/react-query"
import { hasPortfolio } from "@/entities/accountUser"
import { useCurrentNavigation } from "@/features/common/dashboard/hooks/useCurrentNavigation"
import { graphql } from "@/graphql"
import { useGraphQLClient, useSession } from "@/lib/blueprint-auth/client"
import { type MenuItem } from "../types/menuItem"
import { useMenuItemsCollection } from "./useMenuItemCollection"

const ViewerQuery = graphql(
    `
        query Viewer {
            viewer {
                ...hasPortfolio_AccountUser
            }
        }
    `,
    [hasPortfolio.fragments.accountUser]
)

export function useAccountMenu() {
    const menuItems = useMenuItemsCollection()
    const { accountNumber } = useCurrentNavigation()
    const { data: session } = useSession()

    const graphQLClient = useGraphQLClient()

    const { data: user } = useQuery({
        queryKey: ["useAccountMenu"],
        queryFn: () => graphQLClient.request(ViewerQuery),
        enabled: !!session?.isAuthenticated && session.authMethod !== "scoped",
        select: (data) => data.viewer,
    })

    if (!accountNumber) {
        return []
    }

    const items: MenuItem[] = [menuItems.personalDetails, menuItems.pot(accountNumber)]

    if (user && hasPortfolio(user)) {
        items.push(menuItems.accounts)
    }

    return items
}

useAccountMenu.messages = [...useMenuItemsCollection.messages] as const
